import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import { updateUser } from '~/redux/slices/user'

import { impersonateUser } from '../services/impersonate-user.service'

export default function useImpersonateUser() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const user = useAppSelector(state => state.user)

  return useMutation({
    mutationFn: async (username: string) => {
      if (!user) throw new Error('Missing authenticated user')
      return await impersonateUser(username, user.env)
    },
    onSuccess: async ({ homePath, user }) => {
      await queryClient.cancelQueries()
      queryClient.getQueryCache().clear()
      dispatch(updateUser(user))
      navigate(homePath, { replace: true })
    },
  })
}
